import {createClient, Interceptor} from "@connectrpc/connect"
import { Code, ConnectError } from '@connectrpc/connect'
import {createConnectTransport} from "@connectrpc/connect-web"
import { QueryClient } from "@tanstack/react-query"
import { PharmacyService } from "./gen/pharmacy_connect"


const authInterceptor: Interceptor = (next) => async (req) => {
    req.header.set("Authorization", `Bearer ${localStorage.getItem("token") || ""}`)
    try {
        return await next(req)
    } catch (err) {
        if (err instanceof ConnectError && err.code === Code.Unauthenticated) {
            window.location.href = "/login"
        }
        throw err
    }
}

export const transport = createConnectTransport({
    baseUrl: import.meta.env.VITE_API_URL,
    defaultTimeoutMs: 60000, // 60 seconds
    interceptors: [
        authInterceptor
    ]
})

export const queryClient = new QueryClient();

export const pharmacyClient = createClient(PharmacyService, transport)